// import { over } from "lodash";
import { IChartGroups } from "utils/interfaces/report";
import { GraphType } from "utils/enums/graph";
import CommonBarChart from "./commonBarChart";

interface IPerfectGroupedBarCharProps {
  data: IChartGroups[];
  categories: string[];
  graphType: GraphType;
  isYearSelected: boolean;
  colorValueMap: Record<string, string>;
  totalEnrolments: number;
}

const GroupedBarChart: React.FC<IPerfectGroupedBarCharProps> = (props) => {
  const {
    data,
    categories,
    graphType,
    isYearSelected,
    colorValueMap,
    totalEnrolments,
  } = props;

  return (
    <div className="service-chart-box">
      <div className="legend-wrapper">
        <div className="legend-items">
          {Object.entries(colorValueMap).map((item) => (
            <div key={item[0]} className="legend-item">
              <span
                className="legend-color"
                style={{ backgroundColor: item[1] }}
              />
              <span className="legend-text">{item[0]}</span>
            </div>
          ))}
        </div>
        <p className="legend-total">
          <strong>{totalEnrolments}</strong> Total Enrolments
        </p>
      </div>
      <div style={{ width: "100%", overflowX: "auto" }}>
        <CommonBarChart
          graphType={graphType}
          categories={categories}
          percentageData={data}
          isAnimationActive
          colorValueMap={colorValueMap}
          totalEnrolments={totalEnrolments}
        />
        <div className="terms-box">
          <span className="arrow-line" />
          <span>{isYearSelected ? "Years" : "Terms"}</span>
        </div>
      </div>
    </div>
  );
};

export default GroupedBarChart;
